import { useCallback, useState } from 'react';

import { ExecuteFormValues } from '../components/ExecuteForm';
import { WhenFormValues } from '../components/WhenForm';

interface FormValues {
  executeForm: ExecuteFormValues | null;
  whenForm: WhenFormValues | null;
}

interface UseFormValuesResult<StateName extends keyof FormValues> {
  formValues: FormValues;
  updateFormValues: (
    stateName: StateName,
    state: FormValues[StateName],
  ) => void;
}

export function useFormValues<
  StateName extends keyof FormValues,
>(): UseFormValuesResult<StateName> {
  const [formValues, setFormValues] = useState<FormValues>({
    executeForm: null,
    whenForm: null,
  });

  return {
    formValues,
    updateFormValues: useCallback((stateName, state) => {
      setFormValues(previousStates => ({
        ...previousStates,
        [stateName]: state,
      }));
    }, []),
  };
}
